import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/acceptable-use-policy.json";

export default function Page() {
  return <LegalPage title="Acceptable Use Policy" document={document} />;
}
